export const SITE_URL = 'https://www.friendshotel.in';
export const SITE_NAME = 'Friends Hotel';
export const SITE_TWITTER = '@FriendsHotelIn';
export const DEFAULT_OG_IMAGE = 'https://ik.imagekit.io/qtfjtkx2cr/Pelling%20/20251231_082208.jpg?updatedAt=1770389889531';
export const BRAND_PHONE = '+91-6289428163';
export const BRAND_WA = '+918777209081';
export const BRAND_EMAIL = 'booking@friendshotel.in';

export const GEO = {
  region: 'IN-SK',
  placename: 'Sikkim, India',
  position: '27.3314;88.6138',
  icbm: '27.3314, 88.6138',
};

export const ROBOTS_FULL =
  'index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1';
export const ROBOTS_NOINDEX = 'noindex, nofollow';

export const ORG_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  '@id': `${SITE_URL}/#organization`,
  name: 'Friends Hotel Group',
  url: SITE_URL,
  logo: 'https://ik.imagekit.io/ghsourav/FriendsHotel/logo.png',
  telephone: BRAND_PHONE,
  email: BRAND_EMAIL,
  sameAs: [
    'https://www.facebook.com/friendshotel.in',
    'https://www.instagram.com/friendshotel.in',
  ],
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: BRAND_PHONE,
    contactType: 'reservations',
    areaServed: 'IN',
    availableLanguage: ['English', 'Bengali', 'Hindi'],
  },
};
